const PHONE_DIGITS_LENGTH = 10;

export const SBP_PHONE_PLACEHOLDER = '(000) 000-00-00';

export const SBP_INFO_TITLE = 'Что такое СБП?';

export const SBP_INFO_PARAGRAPHS = [
	'Система Быстрых Платежей — это сервис, с помощью которого можно переводить деньги из банка в банк по номеру телефона. Круглосуточно, без выходных и праздников.',
	'Сумму до 100 000 рублей в месяц можно переводить без комиссии, а дальше — с комиссией 0,5% от суммы, но не больше 1 500 рублей.',
	'Более 200 банков уже подключились к СБП.',
] as const;

export const extractSbpPhoneDigits = (value: string): string => {
	const digits = value.replace(/\D/g, '');

	if (digits.startsWith('7') || digits.startsWith('8')) {
		return digits.slice(1, 1 + PHONE_DIGITS_LENGTH);
	}

	return digits.slice(0, PHONE_DIGITS_LENGTH);
};

export const formatSbpPhoneDisplay = (digits: string): string => {
	const normalized = extractSbpPhoneDigits(digits);

	if (!normalized) {
		return '';
	}

	const a = normalized.slice(0, 3);
	const b = normalized.slice(3, 6);
	const c = normalized.slice(6, 8);
	const d = normalized.slice(8, 10);

	if (normalized.length <= 3) {
		return `(${a}`;
	}

	if (normalized.length <= 6) {
		return `(${a}) ${b}`;
	}

	if (normalized.length <= 8) {
		return `(${a}) ${b}-${c}`;
	}

	return `(${a}) ${b}-${c}-${d}`;
};

export const isSbpPhoneValid = (digits: string): boolean => {
	return extractSbpPhoneDigits(digits).length === PHONE_DIGITS_LENGTH;
};

export const formatSbpPhoneForReview = (digits: string): string => {
	const normalized = extractSbpPhoneDigits(digits);

	if (normalized.length !== PHONE_DIGITS_LENGTH) {
		return '—';
	}

	return `+ 7 (${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6, 8)}-${normalized.slice(8, 10)}`;
};

export const formatSbpPhoneForApi = (digits: string): string => {
	const normalized = extractSbpPhoneDigits(digits);

	return normalized.length === PHONE_DIGITS_LENGTH ? `+7${normalized}` : '';
};
